import {CustomTextField} from "../../../../components/CustomTextField";
import { InputAdornment} from "@mui/material";
import {Mail} from "@mui/icons-material";
import {CustomPhoneInput} from "../../../../components/CustomPhoneInput";
import React from "react";
import CustomSelectViewCard from '../../../../components/CustomSelectViewCard';
import {DEFAULT_VISITOR_TYPE} from '../Type/Model/Model';
import {MODELS} from "../../../../Apis/Models";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 * @param {object} userData - Object containing the visitor's data (name, lastName, secondLastName, email, phoneNumber, id, etc.).
 * @param {function} setUserData - Function to update the visitor data state.
 * @param {boolean} disabled - Flag to disable all input fields.
 * @param {function} handleChange - Function to handle changes for text fields.
 * @param {function} handleEmailChange - Function to handle and validate email changes.
 * @param {function} handlePhoneNumberChange - Function to handle and validate phone number changes.
 * @param {boolean} emptyFields - Flag indicating whether required fields are empty (used for validation).
 * @param {boolean} isValidEmail - Flag indicating if the email field is valid.
 * @param {boolean} isValidPhoneNumber - Flag indicating if the phone number field is valid.
 * @param list allVisitorTypes: List of VisitorTypes
 * @param boolean selectVisitorType: Indicates whether the visitor type will be selected
 */
const CreateVisitorForm = (
    {
        userData, setUserData, disabled, handleChange, handleEmailChange, handlePhoneNumberChange,
        emptyFields, isValidEmail, isValidPhoneNumber,
        allVisitorTypes, selectVisitorType=false, moduleId
    }
) => {

    return (
        <>
            <div className='col-sm-12 col-xxl-12 col-lg-12'>
                <CustomTextField
                    id={'txt_cvf_name'}
                    length={32}
                    name={'name'}
                    value={userData.name}
                    trans={'name'}
                    type={'text'}
                    disabled={disabled }
                    onChange={handleChange}
                    emptyFields={emptyFields}
                    required={true}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_cvf_last_name'}
                    length={32}
                    name={'lastName'}
                    value={userData.lastName}
                    trans={'last_name'}
                    type={'text'}
                    disabled={disabled}
                    onChange={handleChange}
                    emptyFields={emptyFields}
                    required={true}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={'txt_cvf_second_last_name'}
                    length={32}
                    disabled={disabled }
                    name={'secondLastName'}
                    value={userData.secondLastName}
                    trans={'second_last_name'}
                    type={'text'}
                    onChange={handleChange}
                    required={false}
                />
            </div>
            <div className='col-sm-12 col-md-12 col-xxl-12 col-lg-12'>
                <CustomTextField
                    id={'txt_cvf_email'}
                    length={64}
                    name={'email'}
                    value={userData.email}
                    trans={'email'}
                    type={'text'}
                    onChange={(e) => {
                        setUserData((prevData) => ({
                            ...prevData,
                            email: e.target.value,
                        }));
                        handleEmailChange(e.target.value);
                    }}
                    emptyFields={emptyFields}
                    required={true}
                    disabled={!!userData.id || disabled }
                    isValid={isValidEmail}
                    isValidText={'email_format_invalid'}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position='end'>
                                <Mail />
                            </InputAdornment>
                        ),
                    }}
                />
            </div>
            <div className='col-sm-12 col-md-12 col-xxl-12 col-lg-12'>
                <CustomPhoneInput
                    id='phit_cvf_phonenumber'
                    value={userData.phoneNumber}
                    onChange={(e) => handlePhoneNumberChange(e, setUserData)}
                    emptyFields={emptyFields}
                    required={true}
                    isValid={isValidPhoneNumber}
                    disabled={ disabled }
                />
            </div>
            { ( selectVisitorType ) &&
                <div className="col-sm-12 col-md-12 col-xxl-12 col-lg-12">
                    <CustomSelectViewCard
                        id='slt_cvif_visitor_types'
                        list={allVisitorTypes.filter(e => moduleId === MODELS.Event ? true : e.name !== DEFAULT_VISITOR_TYPE )}
                        value={userData?.visitorTypeId}
                        name='visitorType'
                        trans='select_visitor_type'
                        required={true}
                        onChange={(evt) => {
                            const selectedId = evt.target.value;
                            setUserData({
                                ...userData,
                                visitorTypeId: selectedId,
                            });
                        }}
                        className='w-100'
                        showNoSelectionOption={false}
                        emptyFields={emptyFields}
                        disabled={false}
                    />
                </div>
            }
        </>
    );
}

export default CreateVisitorForm
